import { z } from 'zod';
import { navbarComponentSchema } from './components/navbar.schemas';
import { navigationMenuComponentSchema } from './components/navigation-menu.schemas';
import {
  heroComponentSchema,
  splitHeroComponentSchema,
  simpleHeaderComponentSchema,
} from './components/hero.schemas';
import { featuresComponentSchema } from './components/features.schemas';
import { ctaComponentSchema } from './components/cta.schemas';
import { footerComponentSchema } from './components/footer.schemas';
import { formComponentSchema, formSplitComponentSchema } from './components/form.schemas';
import { textBlocksComponentSchema } from './components/text-blocks.schemas';
import { teamComponentSchema } from './components/team.schemas';
import { mediaTextComponentSchema } from './components/media-text.schemas';
import { pricingComponentSchema } from './components/pricing.schemas';
import { videoComponentSchema } from './components/video.schemas';
import {
  titleSubtitleComponentSchema,
  contactInfoComponentSchema,
  headContentComponentSchema,
  bodyEndComponentSchema,
  htmlEmbedComponentSchema,
  contentAreaComponentSchema,
} from './components/misc.schemas';
import { faqComponentSchema } from './components/faq.schemas';
import { testimonialsComponentSchema } from './components/testimonials.schemas';
import { countdownTimerComponentSchema } from './components/countdown-timer.schemas';
import { imageGalleryComponentSchema } from './components/image-gallery.schemas';
import { imageInfoComponentSchema } from './components/image-info.schemas';
import { imageCardComponentSchema } from './components/image-card.schemas';
import { promoBannerComponentSchema } from './components/promo-banner.schemas';
import { logocloudComponentSchema } from './components/logocloud.schemas';
import { statsComponentSchema } from './components/stats.schemas';
import { blogPreviewComponentSchema } from './components/blog-preview.schemas';
import { conversionPopupComponentSchema } from './components/conversion-popup.schemas';
import { htmlSplitComponentSchema } from './components/html-split.schemas';
import { competeFormComponentSchema } from './components/compete-form.schemas';

// Union schema for all component types
export const componentSchema = z.discriminatedUnion('type', [
  navbarComponentSchema,
  navigationMenuComponentSchema,
  heroComponentSchema,
  splitHeroComponentSchema,
  simpleHeaderComponentSchema,
  featuresComponentSchema,
  ctaComponentSchema,
  footerComponentSchema,
  formComponentSchema,
  formSplitComponentSchema,
  textBlocksComponentSchema,
  teamComponentSchema,
  mediaTextComponentSchema,
  pricingComponentSchema,
  videoComponentSchema,
  titleSubtitleComponentSchema,
  contactInfoComponentSchema,
  headContentComponentSchema,
  bodyEndComponentSchema,
  htmlEmbedComponentSchema,
  faqComponentSchema,
  testimonialsComponentSchema,
  countdownTimerComponentSchema,
  imageGalleryComponentSchema,
  imageInfoComponentSchema,
  imageCardComponentSchema,
  contentAreaComponentSchema,
  promoBannerComponentSchema,
  logocloudComponentSchema,
  statsComponentSchema,
  blogPreviewComponentSchema,
  conversionPopupComponentSchema,
  htmlSplitComponentSchema,
  competeFormComponentSchema,
]);

// Page components structure
export const pageComponentsSchema = z.object({
  components: z.array(componentSchema),
  metadata: z.object({
    version: z.string().default('1.0'),
    lastModified: z.string().datetime(),
    totalComponents: z.number().int().min(0),
  }),
});

// Type exports
export type Component = z.infer<typeof componentSchema>;
export type PageComponents = z.infer<typeof pageComponentsSchema>;
